import {File} from "./file.interface";

export interface UploadedFilesInterface {
  previewFile: File[];
  file: File[];
}
